import React from "react"

const RRRBlock = () => {
  return (
    <div>
      <svg 
        version="1.1" 
        className="intro-svg" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlnsXlink="http://www.w3.org/1999/xlink" 
        x="0px" 
        y="0px"
        viewBox="0 0 643.1 672.5" 
        xmlSpace="preserve"
        style={{
          maxWidth:"90vw",
          maxHeight:"calc(96vh - 70px)",
          height:"70vh"
        }}
        >
      <style type="text/css">{`
        .st0{fill:#E41087;}
        .st1{fill:#F3C22D;}
        .st2{fill:#8EBC40;}
        .st3{fill:#5090CC;}
        .st4{fill:#6DC0E0;} 
        `}
      </style>
      <path id="Fill_1" className="st0 fine " d="M389.7,670.6L389.7,670.6l-16.5,0l-35.3-105.1l-10-33.4v138.5h-21.2V462.8H327l32.1,106.7l9.4,33.7
        V462.8h21.2V670.6z M512.4,670.6h-16.7v-27.9h16.7L512.4,670.6L512.4,670.6z M480.4,670.6h-66.1V462.8h66.1v20.9h-43.7V553h31.5
        v20.3h-31.5v76.4h43.7L480.4,670.6L480.4,670.6z M282.3,670.6L282.3,670.6L282.3,670.6h-22.8V462.8h22.8L282.3,670.6z M205,670.6
        h-22.8V462.8h64.6v20.6H205v71.4h32.8v20.3H205L205,670.6L205,670.6z"/>
      <path id="Fill_2" className="st1 fine" d="M82.1,672.5h-6.9c-15.6,0-20.9-5.7-20.9-22.5v-53.7c0-10.9-5.2-17.2-14.4-17.2H22.8v91.4H0V462.8
        h41.2c15.8,0,34.6,6.5,34.6,37.4v39.6c0,16.8-5.4,25.9-17.5,29.6c5.9,1.8,10.9,5.8,13.8,11.2c2.8,4.9,4.2,11.2,4.2,18.2v50.2
        c0,6,1.5,8.1,5.6,8.1L82.1,672.5L82.1,672.5z M22.8,484v75.5H39c9,0,14.4-6.4,14.4-17.2v-43.7c0-9.7-4.2-14.7-12.5-14.7H22.8z
         M167.2,670.6h-66.1V462.8h66.1v20.9h-43.7V553h31.5v20.3h-31.5v76.4h43.7V670.6L167.2,670.6z"/>
      <path id="Fill_4" className="st2 focus" d="M577.8,443.9c-11.8,0-21.8-4-28.9-11.4c-7-7.3-10.7-17.5-10.7-29.4v-23.7H560v22.8
        c0,6.8,1.6,12.5,4.6,16.5c3,4,7.8,6.4,12.8,6.2c11.8,0,18.1-7.3,18.1-21.2c0-19.3-6.9-36-23.7-57.7C560,330.7,540,301.3,540,275.1
        c0-13.3,3.4-24.5,9.7-32.3c6.8-8.4,17-12.9,29.6-12.9c22.2,0,37.1,16.6,37.1,41.2v24.6h-21.2v-22.8c0-14.9-5.7-22.8-16.5-22.8
        c-10.9,0-16.8,6.8-16.8,19c-0.2,10.2,1.9,20.2,6.2,29.4c4.4,9.7,11.2,19.4,20,31.1c20.3,26.2,29.3,47.5,29.3,69
        c0,15.2-4.3,27-12.7,35C597.8,440.2,588.2,443.9,577.8,443.9z M484.8,443.9c-11.3,0-21.1-3.9-28.2-11.3
        c-7.3-7.6-11.1-18.1-11.1-30.5V233H468v170.4c0,6.4,1.4,11.3,4.3,14.5c2.8,3.2,7.2,4.9,12.9,4.9s10.1-1.6,12.9-4.9
        c2.8-3.2,4.3-8.1,4.3-14.5V233h21.8v169.1c0,12.4-3.9,22.9-11.2,30.5C505.8,439.9,495.9,443.9,484.8,443.9L484.8,443.9z
         M392.2,443.9c-11.7,0-21.7-4.2-28.9-12.2c-6.9-7.7-10.7-18.5-10.7-30.5V272.6c0-11.9,3.8-22.7,10.7-30.4
        c7.2-8.1,17.2-12.4,28.9-12.4c23.1,0,38.1,16.4,38.1,41.8v34h-19.7v-36.2c0-11-6.9-18.1-17.5-18.1c-11,0-18.1,7-18.1,17.8v135.4
        c0,11,6.9,17.8,18.1,17.8c10.8,0,17.5-6.9,17.5-18.1v-36.5h19.7v34.3C430.2,427.5,415.3,443.9,392.2,443.9L392.2,443.9z
         M296.1,443.9c-11.8,0-21.9-4.2-29.1-12.2c-7.1-7.8-10.8-18.6-10.8-31.2V273.2c0-12.2,3.8-23.3,10.8-31c7.2-8.1,17.3-12.3,29.1-12.3
        c11.8,0,21.8,4.3,29.1,12.3c7,7.8,10.8,18.8,10.8,31v127.3c0,12.5-3.7,23.3-10.8,31.2C317.9,439.6,307.9,443.9,296.1,443.9
        L296.1,443.9z M296.1,251.4c-10.8,0-17.5,7.2-17.5,18.7v133.5c0,5.5,1.5,10.2,4.4,13.5c3,3.4,7.6,5.3,13.1,5.3
        c11,0,17.8-7.2,17.8-18.7V270.1C313.9,258.7,306.9,251.4,296.1,251.4L296.1,251.4z M643.1,440.8h-16.7v-27.9h16.7V440.8z M205,440.8
        h-22.8V233h64.6v20.6H205V325h32.8v20.3H205L205,440.8L205,440.8z"/>
      <path id="Fill_6" className="st3 focus" d="M82.1,442.6h-6.9c-15.6,0-20.9-5.7-20.9-22.5v-53.7c0-10.9-5.2-17.2-14.4-17.2H22.8v91.4H0V233
        h41.2c15.8,0,34.6,6.5,34.6,37.4V310c0,16.8-5.4,25.9-17.5,29.6c5.9,1.8,10.9,5.8,13.8,11.2c2.8,4.9,4.2,11.2,4.2,18.2v50.2
        c0,6,1.5,8.1,5.6,8.1L82.1,442.6L82.1,442.6z M22.8,254.2v75.5H39c9,0,14.4-6.4,14.4-17.2v-43.7c0-9.7-4.2-14.7-12.5-14.7H22.8z
         M167.2,440.8h-66.1V233h66.1v20.9h-43.7v69.3h31.5v20.3h-31.5v76.4h43.7V440.8L167.2,440.8z"/>
      <path id="Fill_8" className="st4 flect" d="M451.2,215c-11.7,0-21.7-4.2-28.9-12.2c-6.9-7.7-10.7-18.5-10.7-30.5V43.7
        c0-11.9,3.8-22.7,10.7-30.4c7.2-8.1,17.2-12.4,28.9-12.4c23.1,0,38.1,16.4,38.1,41.8v34h-19.6V40.6c0-11-6.9-18.1-17.5-18.1
        c-11,0-18.1,7-18.1,17.8v135.4c0,11,6.9,17.8,18.1,17.8c10.8,0,17.5-6.9,17.5-18.1v-36.5h19.6v34.3C489.3,198.6,474.4,215,451.2,215
        z M584.6,211.8h-16.7v-27.9h16.7V211.8z M547.6,211.8h-22.2V25.3h-27.8V4.1h76.8v21.2h-26.8L547.6,211.8L547.6,211.8z M401.6,211.8
        h-66.1V4.1h66.1V25H358v69.3h31.5v20.3H358v76.4h43.7L401.6,211.8L401.6,211.8z M325.8,211.8h-64.6V4.1h22.5v186.3h42.1L325.8,211.8
        L325.8,211.8z M206.7,211.8h-22.8V4.1h64.6v20.6h-41.8v71.4h32.8v20.3h-32.8L206.7,211.8L206.7,211.8z"/>
      <path id="Fill_11" className="st0 flect" d="M82.1,212.8h-6.9c-15.6,0-20.9-5.7-20.9-22.5v-53.7c0-10.9-5.2-17.2-14.4-17.2H22.8v91.4H0V3.1
        h41.2c15.8,0,34.6,6.5,34.6,37.4v39.6c0,16.8-5.4,25.9-17.5,29.6c5.9,1.8,10.9,5.8,13.8,11.2c2.8,4.9,4.2,11.2,4.2,18.2v50.2
        c0,6,1.5,8.1,5.6,8.1L82.1,212.8L82.1,212.8z M22.8,24.3v75.5H39c9,0,14.4-6.4,14.4-17.2V39c0-9.7-4.2-14.7-12.5-14.7L22.8,24.3z
         M167.2,210.9h-66.1V3.1h66.1V24h-43.7v69.3h31.5v20.3h-31.5V190h43.7V210.9L167.2,210.9z"/>
      </svg>
    </div>
  )
}

export default RRRBlock